import React from "react";
import { fetcher } from "../../../config/fetchApiConfig";
import {
  CreateGridData,
  RenderMasterGrid,
} from "../../../helper/Grid/GridCreatorMixin";
import { getApiUrl } from "./../../../config/applicationConfig";
import { doInputEvent } from "./../../../helper/JavascriptHelper";
import { Input } from "antd";
import { useTranslation } from "react-i18next";

const ProductCategoryGrid = () => {
  const { t } = useTranslation();
  const pageGrid = {
    apiController: "ProductCategory",
    apiKey: "Id",
    editTitle: t("productCategoryInfo"),
    editMode: {
      isActive: true,
      mode: "form",
      allowAdding: true,
      allowDeleting: true,
      allowUpdating: true,
      useIcons: true,
      containerColCount: 1,
      validationSummary: true,
    },
    onInitNewRow: (options) => {
      options.data.isShow = true;
    },
    columns: [
      {
        dataField: "Code",
        caption: t("code"),
        editCellComponent: (cell) => {
          const onChange = (value) => {
            cell.setValue(value);
          };
          const handleKeyDown = (e) => {
            if (e.key === "Tab") {
              fetcher(getApiUrl(`/api/ProductCategory/AutoGenerateCode`))
                .then((res) => res.json())
                .then((data) => {
                  var el = document.getElementById("categoryCodeInput");
                  doInputEvent(el, data);
                });
            }
          };
          return (
            <Input
              defaultValue={cell.value}
              maxLength={5}
              minLength={16}
              id="categoryCodeInput"
              onKeyDown={handleKeyDown}
              onChange={(e) => onChange(e.target.value)}
            />
          );
        },
        fieldValidation: {
          isRequired: true,
          stringLength: {
            min: 2,
          },
        },
      },
      {
        dataField: "Name",
        caption: t("name"),
        fieldValidation: {
          isRequired: true,
          stringLength: {
            min: 2,
          },
        },
      },
      {
        dataField: "ShortCode",
        caption: t("shortCode"),
        fieldValidation: {
          isRequired: true,
          stringLength: {
            min: 1,
            max: 5,
          },
        },
      },
      {
        dataField: "IsShow",
        caption: t("views"),
        dataType: "boolean",
      },
    ],
  };

  return <RenderMasterGrid gridData={CreateGridData(pageGrid)} />;
};
export default ProductCategoryGrid;
